import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { createTasksApi, taskKeys } from '../api';
import type { TaskHistoryResult } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseTaskHistoryOptions {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useTaskHistory(id: string, options: UseTaskHistoryOptions = {}): UseQueryResult<TaskHistoryResult> {
  const { enabled = true } = options;
  const client = useApiClient('deliveries');
  const api = createTasksApi(client);

  return useQuery({
    enabled: enabled && id.length > 0,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getTaskHistory(id),
    queryKey: taskKeys.history(id),
    staleTime: LIST_STALE_TIME_MS,
  });
}
